export default __webpack_public_path__ + "static/media/HeartInCircle.0ccf62a8.png";